import { apiRequest } from '@/core';
import { type Demo } from '@/types';

export const fetchDemoRequest = async () =>
  apiRequest<Demo>({
    endpoint: 'api/demo',
  });
